module.exports = __webpack_public_path__ + "static/media/willstock.1cb27e9a.jpeg";